"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.frontEndAddExternalUserAccess = exports.frontEndAddUserAccess = exports.userAccess = void 0;
var joi_1 = __importDefault(require("joi"));
var constants_1 = require("@hobt/constants");
var access_1 = require("./access");
var access_for_external_user_1 = require("./access-for-external-user");
exports.userAccess = joi_1.default.object({
    allowedTransitNumbers: joi_1.default.when(joi_1.default.ref('/userTypeCode'), {
        is: constants_1.UserType.External,
        then: joi_1.default.array()
            .items(joi_1.default.string()
            .min(5)
            .max(5)
            .required()
            .disallow(constants_1.ALL_TRANSIT_ACCESS))
            .required(),
        otherwise: joi_1.default.array()
            .min(1)
            .max(1)
            .items(joi_1.default.string()
            .min(5)
            .max(5)
            .valid(constants_1.ALL_TRANSIT_ACCESS)
            .default(constants_1.ALL_TRANSIT_ACCESS))
            .default([constants_1.ALL_TRANSIT_ACCESS]),
    }),
    defaultFinancialInstitutionCode: joi_1.default.when(joi_1.default.ref('/userTypeCode'), {
        is: constants_1.UserType.External,
        then: joi_1.default.string()
            .min(3)
            .max(3)
            .required(),
        otherwise: joi_1.default.forbidden(),
    }),
    defaultTransitNumber: joi_1.default.when(joi_1.default.ref('/userTypeCode'), {
        is: constants_1.UserType.External,
        then: joi_1.default.string()
            .min(5)
            .max(5)
            .required(),
        otherwise: joi_1.default.forbidden(),
    }),
    financialInstitutionCode: joi_1.default.when(joi_1.default.ref('/userTypeCode'), {
        is: constants_1.UserType.External,
        then: joi_1.default.string()
            .min(3)
            .max(3)
            .required()
            .disallow(constants_1.ALL_FIC_ACCESS),
        otherwise: joi_1.default.string()
            .valid(constants_1.ALL_FIC_ACCESS)
            .default(constants_1.ALL_FIC_ACCESS),
    }),
    lenderCode: joi_1.default.when(joi_1.default.ref('/userTypeCode'), {
        is: constants_1.UserType.External,
        then: joi_1.default.string()
            .min(5)
            .max(5)
            .optional(),
        otherwise: joi_1.default.forbidden(),
    }),
    lenderRoleCode: joi_1.default.number()
        .valid(constants_1.UserRole.ApprovedLender, constants_1.UserRole.LenderAdministrator, constants_1.UserRole.ServiceProvider)
        .when(joi_1.default.ref('/userTypeCode'), {
        is: constants_1.UserType.External,
        then: joi_1.default.required(),
        otherwise: joi_1.default.forbidden(),
    }),
    access: access_1.access.required(),
    statusCode: (_a = joi_1.default.number()).valid.apply(_a, Object.values(constants_1.UserAccessStatus)).default(constants_1.UserAccessStatus.Active),
    userAuthorizationScope: joi_1.default.array()
        .items(joi_1.default.string().valid(constants_1.UserAuthorizationScope.Arrears, constants_1.UserAuthorizationScope.Claim, constants_1.UserAuthorizationScope.Default))
        .optional(),
});
exports.frontEndAddUserAccess = exports.userAccess.keys({
    financialInstitutionCodes: joi_1.default.when(joi_1.default.ref('/userTypeCode'), {
        is: constants_1.UserType.External,
        then: joi_1.default.array()
            .items(joi_1.default.string()
            .min(3)
            .max(3)
            .required())
            .required(),
        otherwise: joi_1.default.array()
            .min(1)
            .max(1)
            .items(joi_1.default.string()
            .min(3)
            .max(3)
            .valid(constants_1.ALL_FIC_ACCESS)
            .default(constants_1.ALL_FIC_ACCESS))
            .default([constants_1.ALL_FIC_ACCESS]),
    }),
    financialInstitutionCode: joi_1.default.forbidden(),
});
exports.frontEndAddExternalUserAccess = exports.frontEndAddUserAccess.keys({
    allowedTransitNumbers: joi_1.default.array()
        .items(joi_1.default.string()
        .min(5)
        .max(5)
        .required()
        .disallow(constants_1.ALL_TRANSIT_ACCESS))
        .required(),
    defaultFinancialInstitutionCode: joi_1.default.string()
        .min(3)
        .max(3)
        .required(),
    defaultTransitNumber: joi_1.default.string()
        .min(5)
        .max(5)
        .required(),
    financialInstitutionCodes: joi_1.default.array().items(joi_1.default.string()
        .min(3)
        .max(3)
        .required()
        .disallow(constants_1.ALL_FIC_ACCESS)),
    financialInstitutionCode: joi_1.default.string()
        .min(3)
        .max(3)
        .required()
        .disallow(constants_1.ALL_FIC_ACCESS),
    lenderRoleCode: joi_1.default.number()
        .valid(constants_1.UserRole.ApprovedLender, constants_1.UserRole.LenderAdministrator, constants_1.UserRole.ServiceProvider)
        .required(),
    access: access_for_external_user_1.accessForExternalUser.required(),
    userAccessID: joi_1.default.string().optional(),
});
